import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Homepage from './components/Homepage'
import GeneratorPage from './components/GeneratorPage'
import Header from './components/Header'
import Footer from './components/Footer'
import About from './components/About'
import GeneratorPage2 from './components/GeneratorPage2'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="min-h-screen gradient-bg relative overflow-hidden">
            <Header />
            <Homepage />
            <Footer />
          </div>
        } />
        <Route path="/generate" element={<GeneratorPage />} />
        <Route path="/generate2" element={<GeneratorPage2 />} />
        <Route path="/about" element={
          <div className="min-h-screen gradient-bg relative overflow-hidden">
            <Header />
            <About />
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  )
}

export default App
